import { useState, useEffect, useCallback } from 'react';

export interface DateRange {
  from: Date | undefined;
  to: Date | undefined;
}

interface StoredDateRange {
  from: string | null;
  to: string | null;
}

const STORAGE_KEY = 'dashboard-date-range';

export function usePersistedDateRange(defaultRange: DateRange = { from: undefined, to: undefined }): [DateRange, (range: DateRange) => void] {
  const [dateRange, setDateRangeState] = useState<DateRange>(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsed: StoredDateRange = JSON.parse(stored);
        return {
          from: parsed.from ? new Date(parsed.from) : undefined,
          to: parsed.to ? new Date(parsed.to) : undefined,
        };
      }
    } catch (error) {
      console.error('Error reading date range from localStorage:', error);
    }
    return defaultRange;
  });

  const setDateRange = useCallback((range: DateRange) => {
    setDateRangeState(range);
    try {
      const toStore: StoredDateRange = {
        from: range.from ? range.from.toISOString() : null,
        to: range.to ? range.to.toISOString() : null,
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(toStore));
    } catch (error) {
      console.error('Error saving date range to localStorage:', error);
    }
  }, []);

  return [dateRange, setDateRange];
}
